export var chalk = {
    hljs: {
        display: 'block',
        overflowX: 'auto',
        padding: '0.5em',
        background: '#151515',
        color: '#F5F5F5',
    },
    'hljs-keyword': {
        color: '#DDB26F',
        fontWeight: 'bold',
    },
    'hljs-selector-tag': {
        color: '#DDB26F',
        fontWeight: 'bold',
    },
    'hljs-literal': {
        color: '#DDB26F',
        fontWeight: 'bold',
    },
    'hljs-section': {
        color: '#DDB26F',
        fontWeight: 'bold',
    },
    'hljs-link': {
        color: '#DDB26F',
    },
    'hljs-subst': {
        color: '#F5F5F5',
    },
    'hljs-string': {
        color: '#EDA987',
    },
    'hljs-title': {
        color: '#EDA987',
        fontWeight: 'bold',
    },
    'hljs-name': {
        color: '#EDA987',
        fontWeight: 'bold',
    },
    'hljs-type': {
        color: '#EDA987',
        fontWeight: 'bold',
    },
    'hljs-attribute': {
        color: '#EDA987',
    },
    'hljs-symbol': {
        color: '#EDA987',
    },
    'hljs-bullet': {
        color: '#EDA987',
    },
    'hljs-built_in': {
        color: '#EDA987',
    },
    'hljs-addition': {
        color: '#EDA987',
    },
    'hljs-variable': {
        color: '#EDA987',
    },
    'hljs-template-tag': {
        color: '#EDA987',
    },
    'hljs-template-variable': {
        color: '#EDA987',
    },
    'hljs-comment': {
        color: '#777',
    },
    'hljs-quote': {
        color: '#777',
    },
    'hljs-deletion': {
        color: '#777',
    },
    'hljs-meta': {
        color: '#777',
    },
    'hljs-doctag': {
        fontWeight: 'bold',
    },
    'hljs-strong': {
        fontWeight: 'bold',
    },
    'hljs-emphasis': {
        fontStyle: 'italic',
    },
    'hljs-number': {
        color: '#ACC267',
    },
};
